module.exports = __webpack_public_path__ + "static/media/back32.0320f562.jpeg";